<ng-container *ngIf="data?.direction && data?.direction === 'Return'">
    AR
</ng-container>
<ng-container *ngIf="data?.direction && data?.direction === 'OneWay'">
    A
</ng-container>
<span class="from-to-part">
<strong>
    {{ data.from | location}}
</strong>
</span>
<span class="from-to-part-arrow" *ngIf="!noArrow">
    <fa-icon [icon]="iconArrowRight"></fa-icon>
</span>
<span class="from-to-part">
    <strong>
    {{ data.to | location}}
</strong>
</span>
